export default "__VITE_ASSET__CQ0HO6zc__ 640w, __VITE_ASSET__DHld5_o8__ 1024w, __VITE_ASSET__B33m4Qtw__ 1536w";